import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8caa4da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "dialog-fate-purchase" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "dialog-paimon-bargain" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Paimon's Bargains")
], -1))
const _hoisted_3 = { id: "dialog-text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" An additional ")
const _hoisted_6 = { class: "fate-coloured" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Purchase with ")
const _hoisted_9 = { class: "fate-coloured" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Primogem? ")
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { id: "dialog-cancel-confirm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cancel_confirm_button = _resolveComponent("cancel-confirm-button")!

  return (_openBlock(), _createElementBlock("div", {
    id: "overlay-fate-purchase",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickOutside && _ctx.clickOutside(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.primoBalance >= _ctx.primogemsNeeded)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.fatesToPurchase), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.useStandardFates ? "Acquaint" : "Intertwined") + " Fate are needed. ", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.primoBalance >= _ctx.primogemsNeeded)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.primogemsNeeded), 1),
              _hoisted_10
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_11, "Not enough Primogems or Fates!"))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_cancel_confirm_button, {
          text: "Cancel",
          onPressed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel-wish')))
        }),
        (_ctx.primoBalance >= _ctx.primogemsNeeded)
          ? (_openBlock(), _createBlock(_component_cancel_confirm_button, {
              key: 0,
              text: "Confirm",
              onPressed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('wish', _ctx.fatesToPurchase)))
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}